// @ts-nocheck
export const INITIALIZE_TABLE_COLUMNS = "INITIALIZE_TABLE_COLUMNS";
export const SET_TABLE_COLUMN_VISIBILITY = "SET_TABLE_COLUMN_VISIBILITY";
export const RESET_TABLE_COLUMN_VISIBILITY = "RESET_TABLE_COLUMN_VISIBILITY";